import React, { useState, useEffect } from "react";
import stockimg from "../assets/stockimage.svg";
import axios from "axios";
import "../assets/animation.css";
import { Link } from "react-router-dom";
import News from "./News";

export default function Main() {
  const [news, setNews] = useState([]);
  const [ipoList, setIpoList] = useState([]);
  useEffect(() => {
    axios
      .get(`/data/news.json?_t=${Date.now()}`)
      .then((response) => {
        setNews(response.data);
      })
      .catch((error) => {
        console.error("Error fetching quarterly results:", error);
      });

    axios
      .get(`/data/ipo.json?_t=${Date.now()}`)
      .then((response) => {
        setIpoList(response.data);
      })
      .catch((error) => {
        console.error("Error fetching quarterly results:", error);
      });
  }, []);

  return (
    <div className="container my-5">
      <div className="intro-block">
        <h3>All in One Stop for </h3>

        <div class="serv-container">
          <div class="word w1">Stock Market</div>
          <div class="word w2">Mutual Funds </div>
          <div class="word w3">ETF's</div>
          <div class="word w4">Crypto</div>
          <div class="word w5">Digi Gold</div>
        </div>

        <div className="hero-block">
          <div class="d-flex main-hero p-3">
            <div class="p-2 hero-image">
              <div className="img-block">
                <img
                  src={stockimg}
                  alt="stock tips"
                  width="70%"
                  class="img-fluid"
                />
              </div>

              <h4 className="pt-1">We help your Money grow.</h4>
              <p>
                Get Daily Stock Market Update | Stock Recommendations | Finance
                Updates
              </p>
            </div>

            <div class="p-2 hero-content ">
              <div class="row hero-row align-items-center justify-content-center  ">
                <div class="col-sm-5 shadow hero-col align-middle stock-col">
                  <Link to="/recos">Recommendations</Link>
                </div>
                <div class="col-sm-5 shadow hero-col dividend-col">
                  <Link to="/dividend">Dividend</Link>
                </div>
                <div class="col-sm-5 shadow hero-col  buy-col">
                  <Link to="/bonus-split">Bonus/Split </Link>
                </div>
                <div class="col-sm-5 shadow hero-col ipo-col">
                  <Link to="/ipo">IPO's</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="news-section light">
        <h2 className="heading">Share Market Latest News</h2>
        <div className="news-list">
          {news.map((item, index) => (
            <div key={index} className="news-card light">
              <div className="news-date">{item.date}</div>
              <div className="news-title">{item.title}</div>
              <div className="news-summary">{item.summary}</div>
            </div>
          ))}
        </div>
      </section>
      <section className="news-section light">
        <h2 className="heading">Top Trending Stocks News Today</h2>
        <div className="updates">
          <News />
        </div>
      </section>
      <section className="news-section ipoSection">
        <h2 className="heading">Open IPO's</h2>
        <div className="updates">
          <div className="table-responsive">
            <table class="table table-hover recommendations-table">
              <thead>
                <tr>
                  <th>Company</th>
                  <th>Closing date</th>
                  <th>Listing date</th>
                </tr>
              </thead>

              <tbody>
                {ipoList.map((i) => {
                  return (
                    <tr>
                      <td className="company-cell">
                        <img
                          src={i.logo}
                          alt={i.companyName}
                          className="company-logo"
                        />
                        <span>{i.companyName}</span>
                      </td>
                      <td>{i.closing_date}</td>
                      <td>{i.listing_date}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </section>
      <section className="news-section light">
        <h2 className="heading">Disclaimer</h2>
        <p>
          StockVia.in is an independent financial information platform created
          solely for informational and educational purposes. We are not a
          registered investment advisor, broker-dealer, or any other type of
          licensed financial professional. The content presented on StockVia —
          including stock recommendations, dividend alerts, IPO details,
          bonus/split updates, financial news, and educational material — is
          curated from publicly available data and verified sources. None of the
          content on this website constitutes, or should be interpreted as,
          investment advice, an offer, or a solicitation to buy or sell any
          securities or financial instruments. Users are strongly encouraged to
          perform their own due diligence or consult with a certified financial
          advisor before making any investment decisions. By using StockVia.in,
          you acknowledge and agree that StockVia does not recommend or endorse
          any specific securities, investment strategies, transactions, or
          financial products, and bears no responsibility for any loss or damage
          arising from reliance on the information provided.
        </p>
        <p>
          Have questions or feedback? Email us at{" "}
          <strong className="primaryColor">stockviaofficial@gmail.com</strong>
        </p>
      </section>
    </div>
  );
}
